/*
 * @Description: 开票记录
 * @Date: 2020年12月14日17:35:52
 * @LastEditors: Please set LastEditors
 */

import { invoice } from '@/api/ajax';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import fields from './fields';

let example = new TableRenderClass({
  fields: {
    ...fields,
    toApplyForTime: {
      label: '申请时间',
      prop: 'createDt'
    },

    theTimeOfMakeOutAnInvoice: {
      label: '开票时间',
      prop: 'authDt'
    }
  },
  search
});

let tobeOpendPart = example.createPart({
  name: '开票记录',
  // search: ['invoicingSupplier', 'invoiceCategory', 'daterange','authDaterange'],
  search: [
    'invoicingSupplier',
    'invoiceBusinessType',
    'daterange',
    'kaipiaoshijian',
    'invoiceStatus'
  ],
  list: invoice.recordsOfMakeOutAnInvoice,
  requestNow: true,
  fields: [
    'index',
    'id', //发票申请编号
    'enterpriseName', //销售方
    'invoiceBusinessType', //业务类型
    'toApplyForTime', //申请时间
    'invoiceAmount', //价税合计
    'invoiceStatus', //开票状态
    // 'invoiceCategory',         //发票类目
    'theTimeOfMakeOutAnInvoice', //开票时间
    'invoiceDetail' //发票详情
  ],
  moreBtnArr: [
    {
      name: '个体自然人发票',
      icon: '',
      type: 'warning',
      async fn(_, table) {
        table.$router.push({
          path: '/v3/project/personInvoice'
        });
      }
    }
  ]
});

export default tobeOpendPart;
